import {IMAGES_URL} from "modules/constants";

export interface IBGImageProps {
	imageSrc: string;
	imageSrcMobile?: string;
}

export const getBGImage = ({imageSrc}: IBGImageProps) => {
	return `url(${IMAGES_URL}image/${imageSrc}) rgba(0, 0, 0, .5) no-repeat center center / cover;`;
};

export const getElementSize = (element: HTMLElement) => {
	const {paddingTop, paddingBottom, paddingLeft, paddingRight} = getComputedStyle(element);

	const elementHeight = element.offsetHeight; // height with padding
	const elementWidth = element.offsetWidth; // width with padding

	return {
		height: elementHeight - parseFloat(paddingTop) - parseFloat(paddingBottom),
		width: elementWidth - parseFloat(paddingLeft) - parseFloat(paddingRight),
	};
};

export * from "./detectLanguage";
export * from "./createConnextraScriptTag";
export * from "./trackIdentify";
export * from "./timeFormat";
export * from "./dayWithNth";
export * from "./getLogo";
